import { Middleware } from 'redux';
import { MiddlewareProcessor, middleWareWrapper } from './middleware-utils';
import { setRuntimeApiProxyRoutesEnabled } from '@codametrix/client-api';
import { getRuntime, runtimeKeys } from '@codametrix/client-runtime';

const bffRoutingMiddlewareProcessor: MiddlewareProcessor = (api, next, action) => {
  const {
    ui: { config }
  }: CMx.ApplicationState = api.getState();

  const runtimeFlag = getRuntime().flag(runtimeKeys.USE_API_PROXY_ROUTES);
  if (runtimeFlag !== undefined) {
    setRuntimeApiProxyRoutesEnabled(runtimeFlag);
  } else {
    setRuntimeApiProxyRoutesEnabled(config.apiProxyServiceEnabled);
  }

  return next(action);
};

const bffRoutingMiddleware: Middleware = middleWareWrapper(
  bffRoutingMiddlewareProcessor
);

export default bffRoutingMiddleware;
